import classNames from 'classnames';
import Select, { OnChangeValue } from 'react-select';

import './dropdown.scss';

type Option = {
    value: string;
    label: string;
};

type Props<Value extends object = Option, IsMulti extends boolean = false> = {
    className?: string;
    placeholder?: string;
    options?: Value[];

    value?: OnChangeValue<Value, IsMulti>;
    onChange?: (option: OnChangeValue<Value, IsMulti>) => void;

    isClearable?: boolean;
    isSearchable?: boolean;
    isMulti?: IsMulti;
};

const Dropdown = <
    Value extends object = Option,
    IsMulti extends boolean = false,
>({
    placeholder,
    options,
    onChange,
    className,
    value,
    isClearable = false,
    isSearchable = false,
    isMulti = false as IsMulti,
}: Props<Value, IsMulti>) => (
    <Select<Value, IsMulti>
        classNamePrefix="dropdown"
        className={classNames('dropdown-root', { [className!]: !!className })}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        options={options}
        isClearable={isClearable}
        isSearchable={isSearchable}
        isMulti={isMulti}
    />
);

export default Dropdown;
